/**
 * RadioGroup Stateless Component
 */
import * as React from "react";
import { Translate } from "react-localize-redux";
import { IRadioGroupProps, IRadioItem } from "root/store/CajitaStore";

const RadioGroup: React.StatelessComponent<IRadioGroupProps> = (
  props: IRadioGroupProps
): React.ReactElement<object> => (
  <div>
    {props.children}
    <div id={props.id}>
      <div
        className="btn-group custom-radio-button-group"
        data-toggle="buttons"
      >
        {props.items.map((item: IRadioItem, index: number) => (
          <div
            key={index}
            className={`btn btn-pse-primary ${
              props.selected === item.value ? "active" : ""
            }`}
          >
            {/* tslint:disable-next-line:use-simple-attributes */}
            <input
              id={`${props.id}-${item.value}`}
              type="radio"
              value={item.value}
              checked={item.value === props.selected}
              onChange={(): void => props.clicked(props.id, item.value)}
            />

            <label
              className="custom-radio-button-group-label"
              htmlFor={`${props.id}-${item.value}`}
            >
              <Translate id={`${props.id}.${item.value}`} />
            </label>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export { RadioGroup };



// WEBPACK FOOTER //
// ./src/components/RadioGroup/RadioGroupComponent.tsx